const yupLocale = {
  mixed: {
    default: {
      key: 'form.validation.invalid',
    },
    required: {
      key: 'form.validation.required',
    },
    // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    oneOf: ({ values }) => ({
      key: 'form.validation.oneOf',
      values: { values },
    }),
  },
  string: {
    email: {
      key: 'form.validation.invalidEmail',
    },
    // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    min: ({ min }) => ({
      key: 'form.validation.min',
      values: { min },
    }),
    // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    max: ({ max }) => ({
      key: 'form.validation.max',
      values: { max },
    }),
    // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    length: ({ length }) => ({
      key: 'form.validation.length',
      values: { length },
    }),
    matches: {
      key: 'form.validation.invalid',
    },
    required: {
      key: 'form.validation.required',
    },
  },
  number: {
    integer: {
      key: 'form.validation.integer',
    },
    // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    min: ({ min }) => ({
      key: 'form.validation.numberMin',
      values: { min },
    }),
    // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    max: ({ max }) => ({
      key: 'form.validation.numberMax',
      values: { max },
    }),
  },
  boolean: {},
  date: {
    // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    min: ({ min }) => ({
      key: 'form.validation.dateMin',
      values: { min },
    }),
    // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    max: ({ max }) => ({
      key: 'form.validation.dateMax',
      values: { max },
    }),
  },
};

export default yupLocale;
